import React from 'react';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { IcepackFormView } from './icepack-form-view';
import {
	getPartnersOptionsSelector,
	getIsPartnersLoadingSelector,
	getFormInitialValuesSelector,
} from '../../selectors';
import { ICEPACK_FORM_NAME } from '../../constants';
import { validate } from '../../utils';

const IcepackFormWrapper = ({ partnersOptions, isPartnersLoading, isLoading }) => (
	<IcepackFormView partnersOptions={partnersOptions} isPartnersLoading={isPartnersLoading} isLoading={isLoading} />
);

const withForm = reduxForm({
	form: ICEPACK_FORM_NAME,
	enableReinitialize: true,
	onSubmit: validate,
})(IcepackFormWrapper);

const mapStateToProps = createStructuredSelector({
	partnersOptions: getPartnersOptionsSelector(),
	isPartnersLoading: getIsPartnersLoadingSelector(),
	initialValues: getFormInitialValuesSelector(),
});

IcepackFormWrapper.propTypes = {
	partnersOptions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.number.isRequired,
			value: PropTypes.number.isRequired,
			text: PropTypes.string,
		}),
	).isRequired,
	isPartnersLoading: PropTypes.bool.isRequired,
	isLoading: PropTypes.bool.isRequired,
	initialValues: PropTypes.object,
};

const IcepackForm = connect(mapStateToProps)(withForm);

export { IcepackForm };
